module.exports = __webpack_public_path__ + "img/170.42a20bbb.jpg";